var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83944 6.77025C9.70899 6.77025 11.2246 5.25468 11.2246 3.38512C11.2246 1.51557 9.70899 0 7.83944 0C5.96989 0 4.45431 1.51557 4.45431 3.38512C4.45431 5.25468 5.96989 6.77025 7.83944 6.77025ZM2.92042 15.9484H1.22786L0.117118 14.8377C-0.0239284 14.4321 -0.152634 13.4519 0.46092 12.7748L2.92042 8.88724C3.28186 8.52581 4.57596 7.83468 6.86092 7.96162L11.0394 8.19957L8.051 11.9814C6.47304 12.0255 3.23778 12.8807 2.92042 15.9484ZM9.16175 12.1397C10.3342 12.3601 12.7214 13.4409 12.8907 16.0009H14.6626L15.5882 14.7579C15.6028 14.7008 15.6224 14.6464 15.6424 14.5908L15.6424 14.5908C15.7679 14.2424 15.9112 13.8444 14.9535 12.4306L13.1816 9.17775C13.0582 8.96618 12.6897 8.53246 12.2031 8.49015L9.16175 12.1397ZM11.9122 15.9987H3.92538C3.73497 13.7983 6.42015 13.0896 7.78654 13.0102C11.4626 13.2218 11.824 15.0819 11.9122 15.9987Z",
    fill: "white",
    fillOpacity: 0.976471
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverUser);
export default __webpack_public_path__ + "static/media/driver-user.5352637e65d41ecbde356ac49cf2440f.svg";
export { ForwardRef as ReactComponent };